/* eslint-disable require-yield,no-console,no-undef */
import { call, put, takeLatest } from 'redux-saga/effects';
import { saveClientInfoApi } from '../../../api/fetch';

function* progressE(action) {
    let { value } = action.payload;

    try {
        yield call(saveClientInfoApi, action.payload);
        yield put({ type: 'CLIENT_INFO', payload: value });
        yield put({ type: 'SEND_WS', payload: { act: 'clientResendInfo', content: value } });
        yield put({ type: 'SCREEN', payload: 'showChat' });
    } catch (e) {
        yield put({ type: 'ERROR', message: e.message });
    }
}

function* SagaSaveClientInfo() {
    yield takeLatest('SAGA_SAVE_CLIENT_INFO', progressE);
}


export default SagaSaveClientInfo;



// WEBPACK FOOTER //
// ./src/redux/saga/actions/SagaSaveClientInfo.js